<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <v-flex lg12>
        <v-card>
          <hpo-filter
            :headers="headers"
            :viewName="viewName"
            v-on:applyFilter="applyFilter"
            v-on:quickFilter="quickFilter"
          ></hpo-filter>
          <v-data-table
            :headers="headers"
            :items="items"
            :options.sync="pagination"
            :server-items-length="total_rows"
            :footer-props="items_per_page"
            :must-sort="true"
            :loading="loading"
            :mobile-breakpoint="100"
          >
            <template v-slot:item="{ item }">
              <tr :id="'r-'+item.ID">
                <td>{{ item.PackageCode }}</td>
                <td class="text-right">{{ item.Weight }}</td>
                <td class="text-right">{{ item.RealWeight }}</td>
                <td class="text-right font-weight-bold">{{ item.ReceivedWeight }}</td>
                <td class="text-right">{{ item.Volume }}</td>
                <td class="text-right font-weight-bold">{{ item.ReceivedVolume }}</td>
                <td class="text-right">{{ item.Amount | currency }}</td>
                <td>{{ item.ImDate | display_date }}</td>
                <td>{{ item.CreatedBy }}</td>
                <td class="text-center">
                  <v-icon medium class="mr-2" @click="gotoDetail(item.ID)">fa-external-link-alt</v-icon>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import configs from "../../configs";
import Filtering from "@/components/Filtering";
import moment from "moment"
import { getCurrentTime, sendErrorNotice } from "@/commons/utils";
import _ from "lodash";

export default {
  components: {
    "hpo-filter": Filtering
  },
  data() {
    let dataType = configs.DATA_TYPE;
    return {
      headers: [
        {
          text: "Bao hàng",
          value: "PackageCode",
          filterable: true,
          quickSearch: true,
          dataType: dataType["String"]
        },
        {
          text: "Cân nặng (TQ)",
          value: "Weight",
          align: "end",
          filterable: true,
          dataType: dataType["Number"]
        },
        {
          text: "Cân thực tế",
          value: "RealWeight",
          align: "end",
          filterable: true,
          dataType: dataType["Number"]
        },
        {
          text: "Cân nặng đã nhập",
          value: "ReceivedWeight",
          align: "end",
          filterable: true,
          dataType: dataType["Number"]
        },
        {
          text: "Số kiện (TQ)",
          value: "Volume",
          align: "end",
          filterable: true,
          dataType: dataType["Number"]
        },
        {
          text: "Số kiện đã nhập",
          value: "ReceivedVolume",
          align: "end",
          filterable: true,
          dataType: dataType["Number"]
        },
        {
          text: "Phí ship",
          value: "Amount",
          align: "end",
          filterable: true,
          dataType: dataType["Number"]
        },
        {
          text: "Ngày nhập",
          value: "ImDate",
          filterable: true,
          dataType: dataType["Date"]
        },
        {
          text: "Người nhập",
          value: "CreatedBy",
          filterable: true,
          dataType: dataType["String"]
        },
        {
          text: "Thao tác",
          value: "",
          align: "center",
          sortable: false,
          filterable: false
        }
      ],
      pagination: { ...configs.PAGINATION, sortBy: ["ID"]},
      items_per_page: _.cloneDeep(configs.ITEMS_PER_PAGE),
      viewName: "bigpackagevn_list",
      filterConditions: [],
      quickFilterConditions: [],
      requireRules: [v => !!v || "Trường dữ liệu không được để trống."],
      dialogPackageDetail: false,
      currentTime: getCurrentTime()
    };
  },
  watch: {
    pagination: {
      handler: function(val, oldVal) {
        let filterConditions = this.$store.state.commons.filterConditions;
        this.filterConditions = !_.isEmpty(filterConditions)
          ? filterConditions[this.viewName]
          : [];
        this.filter_data();
      },
      deep: true
    },
  },
  computed: {
    ...mapState({
      items: state => state.bigPackage.all.data,
      total_rows: state => state.bigPackage.all.total,
      currentItem: state => state.bigPackage.selected,
      notTransit: state => state.bigPackage.notTransit,
      loading: state => state.bigPackage.loading
    }),
    param() {
      let pr = {
        pagination: this.pagination,
        filter: this.filterConditions,
        quickFilter: this.quickFilterConditions
      };
      pr.filter.push({
        column: "Status",
        value: configs.BIG_PACKAGE_STATUS_ENUM.NHAP_KHO_VN,
        condition: "equal"
      });
      return pr;
    }
  },
  methods: {
    filter_data: function() {
      this.$store.dispatch("bigPackage/getList", this.param);
    },
    gotoDetail: function (id) {
      this.$store.commit("bigPackage/setDetail", {
        data: {
          ID: 0,
          CreatedDate: new Date(),
          PackageCode: '',
          Weight: 0,
          Volume: 0,
          Amount: 0
        }
      });
      this.$router.push({
        name: "StoreManagerVNDetail",
        params: {
        Pid: id,
        title: 'Chi tiết nhập kho'
        }
      });
    },
    deleteItem: function(id) {
      window.getApp.$emit("REQUEST_DELETE_DATA", id);
    },    
    applyFilter(filterConditions) {
      let sortBy = this.pagination.sortBy;
      let sortDesc = this.pagination.sortDesc;
      this.pagination = configs.PAGINATION;
      this.pagination.sortBy = sortBy;
      this.pagination.sortDesc = sortDesc;
      this.filterConditions = filterConditions;
      this.filter_data();
    },
    quickFilter(filterConditions) {
      this.quickFilterConditions = filterConditions;
      this.filter_data();
    },
    createData(username = "") {
      this.$store.commit("bigPackage/setDetail", {
        data: {
          ID: 0,
          ImDate: new Date(),
          PackageCode: '',
          BigPackageID: -1,
          Weight: 0,
          Volume: 0,
          Amount: 0
        }
      });
      this.$router.push({
          name: "StoreManagerVNDetail",
          params: {
          Pid: 'nhap-bao-moi',
          title: 'Nhập bao mới'
          }
      });
    },
    saveItem(item) {
      this.$store.dispatch("bigPackage/setDetail", {
        data: item,
        id: item.ID
      });
    },
    saveData() {
      this.saveItem(this.currentItem);
      this.dialogPackageDetail = false;
    },
    closePopup() {
      this.dialogPackageDetail = false;
      this.filter_data();
    },
    getListPackageNotTran() {
      this.$store.dispatch("bigPackage/getListNotTransit");
    }
  },
  mounted() {
    this.getListPackageNotTran();
    this.$root.$emit('REQUEST_ROOT_OPTION', {});
    this.$root.$on("REQUEST_CREATE_DATA", this.createData);
    this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
    this.$root.$on("CONFIRMED_REMOVE_DATA", id => {
      this.$store.dispatch("bigPackage/removeDetail", id);
      setTimeout(this.filter_data, 200);
    });
  },
  beforeDestroy() {
    this.$root.$off("REQUEST_CREATE_DATA", this.createData);
    this.$root.$off("REQUEST_REFRESH_DATA", this.filter_data);
    this.$root.$off("CONFIRMED_REMOVE_DATA");
  }
};
</script>
